<template>
  <transition name="fade">
    <div v-if="isOpen" class="drawer-backdrop" @click.self="closeDrawer">
      <div class="drawer">
        <header class="drawer-header">
          <h5 class="drawer-title">{{ title }}</h5>
          <button class="btn-close" @click="closeDrawer"></button>
        </header>
        <div class="drawer-body">
          <slot></slot>
        </div>
        <footer v-if="$slots.footer" class="drawer-footer">
          <slot name="footer"></slot>
        </footer>
      </div>
    </div>
  </transition>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'BaseDrawer',
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      default: ''
    }
  },
  emits: ['update:isOpen'],
  setup(_, { emit }) {
    const closeDrawer = () => emit('update:isOpen', false);

    return { closeDrawer };
  }
});
</script>

<style src="./base-drawer.component.scss" scoped></style>
